module.exports = __webpack_public_path__ + "static/media/30OIOS10.fbe61099.jpg";